import React from "react";
import { Badge } from "./badge";
import { Check } from "lucide-react";

export const CertificateItem = ({
  imageSrc,
  title,
  issuer,
  verified,
}: {
  imageSrc?: string | null;
  title: string;
  issuer: string;
  verified?: boolean;
}) => (
  <div className="flex items-center gap-4 rounded-lg border border-gray-200 bg-white p-4">
    {imageSrc ? (
      <img
        src={imageSrc}
        width={32}
        height={32}
        className="h-8 w-8 rounded-full object-cover"
        alt={title}
      />
    ) : (
      <div className="h-8 w-8 rounded-full bg-gray-500"></div>
    )}
    <div className="flex grow flex-col">
      <h3 className="text-text-primary font-heading">{title}</h3>
      <p className="text-text-tertiary text-sm">{issuer}</p>
    </div>
    {verified && (
      <Badge variant="affirm" size="lg" radius="rounded">
        <Check />
        Verified by DCM
      </Badge>
    )}
  </div>
);
